import { AfterViewInit, Component, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { SelectionModel } from '@angular/cdk/collections';
import { EventEmitter } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActualSelected, Utils } from '../../utils';
import { MonthModel } from './month.model';
import { CoreComponent } from '../../../core/header/core.component';
import { DummyComponent } from '../../../shared/dummy.component';
import { Router } from '@angular/router';
import { months, monthsNumeric } from '../../../consts';
import { TableService } from './table.service';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.scss'],
    standalone: false
})
export class TableComponent implements OnInit, OnChanges, AfterViewInit {

  constructor(
    public coreComponent: CoreComponent,
    public dummy: DummyComponent,
    private router: Router,
    private tableService: TableService
  ) { }

  @Input() columns: { field: string, title: string, cell: any }[] = [];

  @Input() dataSource: Array<any> = [];
  dataTable: MatTableDataSource<any>; /*Esto es para que se pueda sort, paginator...*/

  displayedColumns: string[] = [];

  @ViewChild(MatSort, { static: false }) sort: MatSort;

  /**Actions */
  @Input() hasButton = false;
  @Input() actionsTemplate: TemplateRef<any>;

  /**Actions Header */
  @Input() hasHeaderActions = false;
  @Input() headerActionsTemplate: TemplateRef<any>;

  /**ShowQr */
  @Input() hasShowQr = false;

  /**Click Row */
  @Input() hasRowClick = false;
  @Output() rowClick = new EventEmitter<any>();

  /**Select row */
  @Input() hasSelect = false;
  selection = new SelectionModel<any>(true, []);
  /** Condition select! */
  @Input() hasCondSelect = false;
  @Input() activities: Array<any> = [];
  @Input() remarkField = '';
  @Input() remarkMessage = '';
  @Input() hasMonthFilter = false;
  @Input() hasObservableFilter = false;
  @Input() hasFilterOldObservable = true;

  // ACCIONES RÁPIDAS --------------------------------------------------

  // Presupuestos y albaranes -----------
  @Output() preInvoiceNumberClick = new EventEmitter<any>();
  @Output() preInvoiceIssuerClick = new EventEmitter<any>();
  // ------------------------

  // Facturas --------------
  @Output() invoiceNumberClick = new EventEmitter<any>();
  @Output() amountNumberClick = new EventEmitter<any>();
  // -----------------------

  // Recurrentes -----------
  @Output() recurrentNumberClick = new EventEmitter<any>();
  // -----------------------

  @Output() descriptionInvestmentClick = new EventEmitter<any>();
  @Output() providerInvestmentClick = new EventEmitter<any>();

  // Conceptos -------------
  @Output() nameConceptClick = new EventEmitter<any>();
  @Output() unitsEnter = new EventEmitter<any>();
  // -----------------------

  // Tickets -----------
  @Output() ticketNumberClick = new EventEmitter<any>();
  @Output() amountClick = new EventEmitter<any>();
  // -------------------

  // Contactos ----------------
  @Output() entranceAccountClientClick = new EventEmitter<any>();
  @Output() entranceAccountProviderClick = new EventEmitter<any>();
  // --------------------------

  // Nóminas ----------------------
  @Output() employeeNameClick = new EventEmitter<any>();
  @Output() salaryBrutClick = new EventEmitter<any>();
  @Output() salaryNetClick = new EventEmitter<any>();
  @Output() segSocialCompanyClick = new EventEmitter<any>();
  @Output() segSocialWorkerClick = new EventEmitter<any>();
  // ------------------------------

  // Salary data -----------
  @Output() selectedChange = new EventEmitter<any[]>();
  // -----------------------

  @Output() receiptNumberClick = new EventEmitter<any>();
  @Output() commentsAdminPanelUserClick = new EventEmitter<any>();

  // FIN ACCIONES RÁPIDAS -----------------------------------------------

  months = new UntypedFormControl(this.coreComponent.month);
  monthList: MonthModel[] = [];
  flagFocus = false;
  updateTable = false;
  month = this.coreComponent.month;
  allMonthsSelected = false;
  @ViewChild('monthSelect', {static: false}) monthSelect: MatSelect;

  /*Conditions styles*/
  @Input() styleRowPendingPay: string = '';

  @Input() customTemplates: { [key: string]: TemplateRef<any> }; // Aquí recibes los templates

  /*context para el ng-template, acciones*/
  ctx;

  /* Cabecera - Totales */
  @Input() showTotals: boolean = false;
  @Input() showTotalsHasOptionToPay: boolean = false;
  @Input() textPaided: string = 'Pagado';
  @Input() textUnpaid: string = 'No Pagado';
  total: number = 0;
  totalPaided: number = 0;
  totalUnpaided: number = 0;
  public irpfTotals: boolean = false;
  public base: number = 0;
  public irpfAmount: number = 0;

  filter: string = '';

  isLoad = true;

  ngOnInit() {
    this.displayedColumns = this.columns.map(c => c.field);

    /*si no hay condición para el select, se añade la columna del select*/
    /*si hay condición para el select, se utiliza la columna con field = isSelectRow */
    if (this.hasSelect && !this.hasCondSelect) { this.displayedColumns = ['select'].concat(this.displayedColumns); }

    if (this.hasShowQr) { this.displayedColumns = this.displayedColumns.concat(['showQr']); }

    if (this.hasButton) { this.displayedColumns = this.displayedColumns.concat(['actions']); }

    this.dataTable = null;
    this.dataTable = new MatTableDataSource<any>(this.dataSource);
    this.dataTable.sort = this.sort;
    this.setMonths();

    this.calculateTotalsDataTable();

    this.selection.changed.subscribe(elements => {
      if (this.selection.selected.length > 0) {
        this.calculateTotalsSelection();
      } else {
        this.calculateTotalsDataTable();
      }

      this.selectedChange.emit(this.selection.selected);

    });

    const columnsExcludedFromFilter: string[] = ['uid', 'receiverUid'];

    this.tableService.get().subscribe(result => {
      this.dataSource = result;

      this.displayedColumns = this.columns.map(c => c.field);

      /*si no hay condición para el select, se añade la columna del select*/
      /*si hay condición para el select, se utiliza la columna con field = isSelectRow */
      if (this.hasSelect && !this.hasCondSelect) { this.displayedColumns = ['select'].concat(this.displayedColumns); }

      if (this.hasShowQr) { this.displayedColumns = this.displayedColumns.concat(['showQr']); }

      if (this.hasButton) { this.displayedColumns = this.displayedColumns.concat(['actions']); }

      this.dataTable = null;
      this.dataTable = new MatTableDataSource<any>(this.dataSource);
      this.dataTable.sort = this.sort;

      this.calculateTotalsDataTable();

      this.selection.changed.subscribe(elements => {
        if (this.selection.selected.length > 0) {
          this.calculateTotalsSelection();
        } else {
          this.calculateTotalsDataTable();
        }
      });

      // Aplicamos control al filtro para normalizar los datos a filtrar
      this.dataTable.filterPredicate = (data: Element, filter: string) => {
        const normalizedFilter = this.normalize(filter);
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            if (!columnsExcludedFromFilter.includes(key)) {
              const value = data[key];
              let normalizedDataValue = '';
              if (typeof value === 'string') {
                normalizedDataValue = this.normalize(value);
              } else if (typeof value === 'number') {
                // Si es un número, no lo normalizamos
                normalizedDataValue = value.toString();
              }
              if (normalizedDataValue.includes(normalizedFilter)) {
                return true;
              }
            }
          }
        }
        return false;
      };

      if (this.isLoad) {
        this.isLoad = false;
        // Filter session
        const currentUrl = window.location.href;
        this.filter = localStorage.getItem(currentUrl);

        if (this.filter) {
          this.filter = JSON.parse(this.filter);
          // this.applyFilter(this.filter);
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // La tabla también recibe datos "frescos" vía TableService.set()/get()
    // (Subject global, sin replay), que el padre dispara justo después de
    // fetchear la lista. Si ese emit ocurre antes de que este componente
    // termine de suscribirse (p.ej. justo al recrearse tras volver de
    // editar), se pierde y la tabla se queda con lo que tuviera dataTable
    // en ese momento (datos sin ordenar/obsoletos) hasta el próximo fetch.
    // Reconstruir aquí, reaccionando al propio @Input(), no depende de esa
    // carrera.
    if (changes.dataSource && !changes.dataSource.firstChange && this.dataSource) {
      this.dataTable = new MatTableDataSource<any>(this.dataSource);
      this.dataTable.sort = this.sort;
      this.calculateTotalsDataTable();
    }
  }

  ngAfterViewInit(): void {
    // `sort` (ViewChild con static:false) no está disponible hasta después de
    // ngOnInit, así que la conexión dataTable.sort = this.sort hecha allí llega
    // tarde (this.sort es undefined en ese momento) y el ordenado por cabecera
    // nunca queda enganchado. Se reconecta aquí, una vez la vista ya existe.
    if (this.dataTable) {
      this.dataTable.sort = this.sort;
    }
  }

  getColumnTooltip(column: any, row: any): string {
    if (!column) {
      return '';
    }

    if (!column.tooltip) {
      return '';
    }

    return column.tooltip(row);
  }

  disableColumnTooltip(column: any, row: any): boolean {
    const tooltipText = this.getColumnTooltip(column, row);

    if (!tooltipText) {
      return true;
    }

    return false;
  }

  onUnitsInput(event: any, row: any) {
    row.units = +event.target.value; // Actualiza el valor de units en la fila actual
  }

  onUnitsSubmit(row: any) {
    this.unitsEnter.emit(row);
  }

  //Justificantes
  handleReceiptNumber(justificante) {
    this.receiptNumberClick.emit(justificante);
  }

  handleAmount(justificante) {
    this.amountClick.emit(justificante);
  }

  //Concepts
  handleNameConceptClick(row: any) {
    this.nameConceptClick.emit(row);
  }

  //Contacts
  handleEntranceAccountClient(row: any) {
    this.entranceAccountClientClick.emit(row);
  }

  handleEntranceAccountProvider(row: any) {
    this.entranceAccountProviderClick.emit(row);
  }

  // Admin listado de usuarios
  handleCommentsAdminPanelUserClick(commentForUserId) {
    this.commentsAdminPanelUserClick.emit(commentForUserId);
  }

  //Investments
  handleDescriptionInvestmentClick(investment) {
    this.descriptionInvestmentClick.emit(investment);
  }

  handleProviderInvestmentClick(investment) {
    this.providerInvestmentClick.emit(investment);
  }

  //Preinvoice
  handlePreInvoiceNumberClick(preinvoice) {
    this.preInvoiceNumberClick.emit(preinvoice);
  }

  handlePreInvoiceIssuerClick(preinvoice) {
    if (preinvoice.isReceptor) {
      this.preInvoiceIssuerClick.emit(preinvoice);
    }

    if (preinvoice.invoiceNumber == null) {
      this.preInvoiceIssuerClick.emit(preinvoice);
    }

  }

  //Recurrent
  handleRecurrentNumberClick(recurrent) {
    this.recurrentNumberClick.emit(recurrent);
  }

  //Ticket
  handleTicketNumberClick(ticket) {
    this.ticketNumberClick.emit(ticket);
  }

  //Invoice
  handleInvoiceNumberClick(invoice) {
    this.invoiceNumberClick.emit(invoice); // Emitir el uid de invoice
  }

  handleAmountNumberClick(invoice) {
    this.amountNumberClick.emit(invoice); // Emitir el uid de invoice
  }

  //Nóminas
  handleEmployeeNameClick(row: any) {
    this.employeeNameClick.emit(row);
  }

  handleSalaryBrutClick(row: any) {
    this.salaryBrutClick.emit(row);
  }

  handleSalaryNetClick(row: any) {
    this.salaryNetClick.emit(row);
  }

  handleSegSocialCompanyClick(row: any) {
    this.segSocialCompanyClick.emit(row);
  }

  handleSegSocialWorkerClick(row: any) {
    this.segSocialWorkerClick.emit(row);
  }

  //-----------------------------------------------------------

  // Normaliza la cadena eliminando diacríticos y convirtiéndola a minúsculas
  // NFD Descompone la consonante por ejemplo ñ -> n -> ~
  // Las definidas son Acento grave, Acento agudo, Tilde, Cedilla, Diéresis
  normalize(str: string): string {
    return str.normalize('NFD').replace(/[\u0300\u0301\u0303\u0327\u0308]/g, '').toLowerCase();
  }

  setRow(row) {
    this.ctx = {
      uid: row.uid,
      imageId: row.imageId,
      fileId: row.fileId,
      row,
    };
  }

  setSelected() {
    this.ctx = { selected: this.selection.selected.map(item => item.uid) };
  }

  public applyFilter(filterValue: string): void {
    if (this.hasObservableFilter) {
      this.tableService.onSetFilter(filterValue.trim().toLowerCase());
    } else {
      this.selection.clear();
      this.dataTable.filter = filterValue.trim().toLowerCase();

      this.calculateTotalsDataTable();
    }

    // Filter storage
    const currentUrl = window.location.href;
    localStorage.setItem(currentUrl, JSON.stringify(filterValue));
  }

  clickRow(row) {
    this.rowClick.emit(row);
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    if (this.dataTable.filter !== '') {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataTable.filteredData.length;
      return numSelected === numRows;
    } else {
      const numSelected = this.selection.selected.length;
      const numRows = this.dataTable.data.length;
      return numSelected === numRows;
    }
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataTable.filteredData.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  checkRemarkField(row) {
    if (this.remarkField !== '' && this.remarkField !== undefined && this.remarkField != null) {
      return row[this.remarkField];
    }
  }
  getRemarkMessage(row) {
    if (this.remarkField !== '' && this.remarkField !== undefined && this.remarkField != null) {
      if (this.remarkMessage !== '' && this.remarkMessage !== undefined && this.remarkMessage != null) {
        return row[this.remarkMessage];
      }
    }
  }

  checkStyleRowPendingPay(row): string {
    if (!Utils.IsNullOrEmpty(this.styleRowPendingPay)) {

      if (row.invoiceExpiration != undefined) {

        const actualDateInit = new Date();
        actualDateInit.setHours(0, 0, 0, 0);
        const actualDate = new Date(actualDateInit.toISOString());

        const expirationDateInit = new Date(row.invoiceExpiration);
        expirationDateInit.setHours(0, 0, 0, 0);
        const expirationDate = new Date(expirationDateInit.toISOString());

        const datefromAPITimeStamp = (new Date(expirationDate)).getTime();
        const nowTimeStamp = actualDate.getTime();

        const microSecondsDiff = Math.abs(datefromAPITimeStamp - nowTimeStamp);

        const daysDiff = Math.round(microSecondsDiff / (1000 * 60 * 60 * 24));

        if (daysDiff > 0 && daysDiff <= 5) {
          return this.styleRowPendingPay;
        }

      }

    }
  }

  setMonths() {
    let i = 1;
    months.forEach(element => {
      const newMonth = new MonthModel();
      newMonth.name = element;
      newMonth.number = i.toString();
      this.monthList.push(newMonth);
      i += 1;
    });

    if (ActualSelected.monthSelected === monthsNumeric) {
      this.allMonthsSelected = true;
    }
  }

  onFocusSelect(event: boolean) {
    this.flagFocus = event;
    if (!this.flagFocus && this.updateTable) {
      this.updateTable = false;
      this.dummy.redirectTo(this.router.url);
    }
  }

  onChangeMonth(event) {
    this.updateTable = true;
    this.coreComponent.month = event.value;
    ActualSelected.monthSelected = event.value;
  }

  onSelectAll(event) {
    this.updateTable = true;
    if (event.checked) {
      this.allMonthsSelected = true;
      this.monthSelect.options.forEach((item: MatOption) => item.select());
      this.coreComponent.month = monthsNumeric;
      ActualSelected.monthSelected = monthsNumeric;
    } else {
      this.allMonthsSelected = false;
      this.monthSelect.options.forEach((item: MatOption) => { item.deselect(); });
      this.coreComponent.month = [];
      ActualSelected.monthSelected = [];
    }
  }

  private calculateTotalsDataTable(): void {

    if (this.showTotals) {

      this.total = 0;
      this.totalPaided = 0;
      this.totalUnpaided = 0;

      this.base = 0;
      this.irpfAmount = 0;

      // De esta forma identificamos si es un listado de IRPF
      const firstElement = this.dataTable.filteredData[0];

      if (firstElement) {
        if (firstElement.percent != null && firstElement.amount != null) {
          this.irpfTotals = true;

          for (let i = 0; i < this.dataTable.filteredData.length; i++) {
            const element = this.dataTable.filteredData[i];

            this.base += element.base;
            this.irpfAmount += element.amount;
          }

          this.base = Utils.GetValueWithDecimals(this.base);
          this.irpfAmount = Utils.GetValueWithDecimals(this.irpfAmount);

          return;
        }
      }


      for (let i = 0; i < this.dataTable.filteredData.length; i++) {
        const element = this.dataTable.filteredData[i];
        if (element.rectifying != null) {
          if (element.rectifying === false) {
            this.total += element.total;
            this.totalPaided += element.totalPaided;
            this.totalUnpaided += (element.total - element.totalPaided);
          }
        }
        else {
          this.total += element.total;
          this.totalPaided += element.totalPaided;
          this.totalUnpaided += (element.total - element.totalPaided);
        }
      }

      this.total = Utils.GetValueWithDecimals(this.total);
      this.totalPaided = Utils.GetValueWithDecimals(this.totalPaided);
      this.totalUnpaided = Utils.GetValueWithDecimals(this.totalUnpaided);
    }

  }

  private calculateTotalsSelection(): void {

    if (this.showTotals) {

      this.total = 0;
      this.totalPaided = 0;
      this.totalUnpaided = 0;


      this.base = 0;
      this.irpfAmount = 0;

      // De esta forma identificamos si es un listado de IRPF
      const firstElement = this.selection.selected[0];

      if (firstElement) {
        if (firstElement.percent != null && firstElement.amount != null) {
          this.irpfTotals = true;

          for (let i = 0; i < this.selection.selected.length; i++) {
            const element = this.selection.selected[i];

            this.base += element.base;
            this.irpfAmount += element.amount;
          }

          this.base = Utils.GetValueWithDecimals(this.base);
          this.irpfAmount = Utils.GetValueWithDecimals(this.irpfAmount);

          return;
        }
      }

      for (let i = 0; i < this.selection.selected.length; i++) {
        const element = this.selection.selected[i];

        if (element.rectifying != null) {
          if (element.rectifying === false) {
            this.total += Utils.GetValueWithDecimals(element.total);
            if (this.showTotalsHasOptionToPay === true) {
              this.totalPaided += Utils.GetValueWithDecimals(element.totalPaided);
              this.totalUnpaided += Utils.GetValueWithDecimals((element.total - element.totalPaided));
            }
          }
        } else {
          this.total += Utils.GetValueWithDecimals(element.total);
          if (this.showTotalsHasOptionToPay === true) {
            this.totalPaided += Utils.GetValueWithDecimals(element.totalPaided);
            this.totalUnpaided += Utils.GetValueWithDecimals((element.total - element.totalPaided));
          }
        }
      }

      this.total = Utils.GetValueWithDecimals(this.total);
      if (this.showTotalsHasOptionToPay === true) {
        this.totalPaided = Utils.GetValueWithDecimals(this.totalPaided);
        this.totalUnpaided = Utils.GetValueWithDecimals(this.totalUnpaided);
      }

    }

  }

  getSelectedMonthsNames(): string {
    const selectedNames = this.month.map(index => this.monthList[parseInt(index) - 1].name);
    return selectedNames.join(', ');
  }

  public keyDownEnterPress(event: any): void {
    this.applyFilter(this.filter);
  }



  public trackByIndex(i: number) { return i; }

}
